/**
 * Screener form page URL
 *
 * The page cache can leave another visitor's URL in the page URL field ({embed_url}). Replace it with the browser's
 * URL, which the webhook sends and parses tracking params from (includes/gravity-forms.php).
 */

/**
 * Set every screener page URL field to the current page URL, without the hash
 *
 * @return {void}
 */
export function setScreenerPageUrls() {
	const { origin, pathname, search } = window.location;
	document
		.querySelectorAll('form.screener-form .screener-url input')
		.forEach((input) => {
			input.value = `${origin}${pathname}${search}`;
		});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', setScreenerPageUrls);
} else {
	setScreenerPageUrls();
}
